import Vue from 'vue';
import { AxiosInstance } from 'axios';
import { APP_PROD } from '@/config';

// @ts-ignore
import { UrlParser } from 'url-params-parser';

export default class _Api {
   static http(): AxiosInstance {
      Vue.prototype.$http.defaults.headers.common['Authorization-host'] = UrlParser(APP_PROD ? document.referrer : window.location.href).hostname;
      return Vue.prototype.$http;
   }
}
